(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lirea-antes-despues"] && !Shopify.designMode) return;
  try {
    
function setupLireaComparison(root) {
  const range=root.querySelector('.lirea-ba__range'), comparison=root.querySelector('.lirea-ba__comparison');
  if(!range || root.dataset.ready)return;
  root.dataset.ready='1';
  range.addEventListener('input',()=>comparison.style.setProperty('--split',range.value+'%'));
}
document.querySelectorAll('.lirea-ba').forEach(setupLireaComparison);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.lirea-ba').forEach(setupLireaComparison));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lirea-galeria-producto"] && !Shopify.designMode) return;
  try {
    
function initializeLireaGallery() {
  document.querySelectorAll('[data-lirea-gallery]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const cards = [...section.querySelectorAll('.lpg__card')];
    const more = section.querySelector('.lpg__more');
    const dialog = section.querySelector('dialog');
    const image = section.querySelector('.lpg__full');
    more?.addEventListener('click', () => {
      cards.filter(card => card.hidden).slice(0, 12).forEach(card => { card.hidden = false; });
      more.hidden = !cards.some(card => card.hidden);
    });
    cards.forEach(card => card.addEventListener('click', () => {
      image.src = card.dataset.photo;
      image.alt = card.querySelector('img').alt;
      dialog.showModal();
    }));
    section.querySelector('.lpg__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  });
}
initializeLireaGallery();
document.addEventListener('shopify:section:load', initializeLireaGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lirea-opiniones-producto"] && !Shopify.designMode) return;
  try {
    
function setupProductReviews(root){
  if(root.dataset.ready)return;
  root.dataset.ready='1';
  const cards=[...root.querySelectorAll('.lop__card')], more=root.querySelector('.lop__more'), progress=root.querySelector('.lop__progress');
  const copy=root.querySelector('.lop__translations').content;
  const readMore=copy.querySelector('[data-more]').textContent, readLess=copy.querySelector('[data-less]').textContent, progressText=copy.querySelector('[data-progress]').textContent;
  let visible=12, filter='all';
  const filtered=()=>cards.filter(card=>filter==='all'||card.querySelector('.lop__photo'));
  root.classList.add('lop--ready');
  function refresh(){const current=filtered();cards.forEach(card=>card.hidden=!current.slice(0,visible).includes(card));more.hidden=visible>=current.length;progress.textContent=progressText.replace('__VISIBLE__',Math.min(visible,current.length)).replace('320',String(current.length));measure();}
  function measure(){cards.filter(card=>!card.hidden).forEach(card=>{const text=card.querySelector('.lop__text'),button=card.querySelector('.lop__expand');button.hidden=!card.classList.contains('lop--expanded')&&text.scrollHeight<=text.clientHeight+1;});}
  cards.forEach(card=>card.querySelector('.lop__expand').addEventListener('click',()=>{const expanded=card.classList.toggle('lop--expanded');const button=card.querySelector('.lop__expand');button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?readLess:readMore;}));
  more.addEventListener('click',()=>{const next=filtered()[visible];visible+=12;refresh();next?.scrollIntoView({behavior:'smooth',block:'nearest'});});
  root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{filter=button.dataset.filter;visible=12;root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));refresh();}));
  refresh();
  window.addEventListener('resize',measure);
}
document.querySelectorAll('.lop').forEach(setupProductReviews);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.lop').forEach(setupProductReviews));

  } catch(e) { console.error(e); }
})();
})();
